import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import CustomerView from "./customer_view";

import Utility from "../../../../utility/utility";


const { ccclass, property } = cc._decorator;

@ccclass
export default class WebViewCtrl extends cc.Component {
    onWebFinishLoad(sender, event){
        var loadStatus = "";
        if (event === cc.WebView.EventType.LOADED) {
            loadStatus = " is loaded!";
            cc.systemEvent.emit("customerWebLoaded")
        } else if (event === cc.WebView.EventType.LOADING) {
            loadStatus = " is loading!";
            cc.systemEvent.emit("customerWebLoading",sender["_url"])
        } else if (event === cc.WebView.EventType.ERROR) {
            loadStatus = ' load error!';
            cc.systemEvent.emit("customerWebLoadError")
        }
        cc.log("webview",loadStatus,sender["_url"])
    }
}
